import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./courseCard.css";
import { useGlobalContext } from "../../context/globalContext";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";

const CourseCard = (props) => {
  const { data } = props;
  const location = useLocation();

  const hasExamination = location.pathname.includes("examination");

  const navigate = useNavigate();

  const { setActiveMenu } = useGlobalContext();

  const handleCourseClick = async (course_data) => {
    const data = {
      course_data: course_data,
    };
    const naivgate_url = "/course/details/" + course_data.id;
    setActiveMenu("#");
    navigate(naivgate_url, { state: data });
  };

  const handleStartTestClick = (test_id) => {
    const url = "/examination/home/exam/start/" + test_id;
    navigate(url);
  };

  return (
    <>
      {data.length == 0 ? (
        hasExamination ? (
          <div className="coming-soon-container d-flex flex-column justify-content-center align-items-center text-center">
            <h1 className="coming-soon-title">Please Register</h1>
            <p className="coming-soon-subtext">
              Please contact us in case of an enquiry
            </p>
            <div className="container-button">
              <button className="primary-button btn btn-primary btn-lg custom-shadow top-banner-button">
                Register Now
              </button>
            </div>
          </div>
        ) : (
          <div className="coming-soon-container d-flex flex-column justify-content-center align-items-center text-center">
            <h1 className="coming-soon-title">Courses Coming Soon</h1>
            <p className="coming-soon-subtext">
              Please contact us in case of an enquiry
            </p>
            <div className="container-button">
              <button className="primary-button btn btn-primary btn-lg custom-shadow top-banner-button">
                Enquire Now
              </button>
            </div>
          </div>
        )
      ) : (
        data.map((card, index) => (
          <div
            className="col course-card-div"
            key={index}
            onClick={() => {
              if (card?.course_type != 3) {
                handleCourseClick(card);
              }
            }}
          >
            <div
              className="card custom-shadow course-card rounded-4 overflow-hidden h-100"
              style={{ maxWidth: "100%" }}
            >
              <div
                className="rounded-4"
                style={{
                  height: "16rem",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={card?.image}
                  className="w-100"
                  alt={card?.name}
                  style={{ objectFit: "cover", height: "100%" }}
                />
                <span className="badge bg-primary primary-button position-absolute top-0 start-0 m-2">
                  {card?.tag}
                </span>
              </div>

              <div className="card-body p-3">
                {card?.course_type != undefined &&
                [2].includes(card.course_type) ? (
                  <></>
                ) : (
                  <small className="text-warning fw-bold text-uppercase">
                    {card?.subject}
                  </small>
                )}
                <div className="d-flex align-items-center mt-1 mb-2">
                  {card?.course_type != undefined &&
                  [3].includes(card.course_type) ? (
                    <>
                      <i className="bi bi-people-fill  me-1"></i>
                      {/* <span className="fw-semibold">{card?.rating}</span> */}
                      <span className="text-muted ms-1">
                        {card?.attempting} Attending
                      </span>
                    </>
                  ) : (
                    <>
                      <i className="bi bi-star-fill text-warning me-1"></i>
                      <span className="fw-semibold">{card?.rating}</span>
                      <span className="text-muted ms-1">
                        ({card?.rated_users})
                      </span>
                    </>
                  )}
                </div>
                <h4 className="fw-bold mb-1">{card?.name}</h4>
                <p className="text-muted small mb-2">{card?.outer_text}</p>
                {/* <div className="d-flex align-items-center mb-2">
                  <img
                    src="https://i.pravatar.cc/24?img=1"
                    className="rounded-circle me-2"
                    width="24"
                    height="24"
                    alt="Instructor"
                  />
                  <strong className="small">{card.teacher}</strong>
                </div> */}
                {card?.course_type != undefined && card?.course_type == 2 ? (
                  <></>
                ) : (
                  <div className="d-flex justify-content-between text-muted small">
                    <div>
                      <i className="bi bi-clock me-1"></i>
                      {card?.duration}
                    </div>
                    <div>
                      <i className="bi bi-play-circle me-1"></i>
                      {card?.content_type}
                    </div>
                  </div>
                )}
                {card && card.course_type === 3 && (
                  <div className="navbar-brand d-block text-center order-2 order-md-1 mx-auto">
                    <button
                      className="primary-button btn btn-primary mx-3 custom-shadow"
                      disabled={!card.is_ongoing}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (card.is_ongoing) handleStartTestClick(card.id);
                      }}
                      style={{
                        opacity: card.is_ongoing ? 1 : 0.5,
                        cursor: card.is_ongoing ? "pointer" : "not-allowed",
                      }}
                    >
                      {card.terminated
                        ? "Test Terminated"
                        : card.closed
                        ? "Test Closed"
                        : card.completed
                        ? "Test Submitted"
                        : card.is_ongoing
                        ? "Attempt Test"
                        : "Opens Soon"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))
      )}
      {}
    </>
  );
};

export default CourseCard;
